import PropTypes from 'prop-types'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

import { certifiedAccolade } from '../../utility/coaches'

import classes from './CoachStatus.module.scss'

const STATUS_CLASS_NAMES = { certified: classes.active, in_progress: classes.invited }

const CoachCertification = ({ coach }) => {
  const { t } = useTranslation()
  const status = coach.certification_status || 'not_started'
  const certification = certifiedAccolade(coach)

  if (status === 'certified' && certification?.issued_date) {
    return <span className={classes.active}>{t('coaches.table.certified', { year: moment(certification.issued_date).format('YYYY') })}</span>
  }

  return <span className={STATUS_CLASS_NAMES[status] || classes.inactive}>{t(`coaches.table.certificationStatuses.${status}`)}</span>
}

CoachCertification.propTypes = {
  coach: PropTypes.shape({ certification_status: PropTypes.string, user_accolades: PropTypes.array }).isRequired,
}

export default CoachCertification
